import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckPenIcon, ChevronRightIcon } from '@prophecy/icons';
import { theme } from '@prophecy/theme';
import { useControlledState } from '@prophecy/utils/react/hooks';
import React from 'react';
import { Stack } from '../../Layout';
import { TabVariant } from '../../Tabs';
import { Tooltip } from '../../Tooltip';
import { Text } from '../../Typography';
import { StyledTabsRoot, StyledTabsList, StepIconContainer } from '../sharedStyled';
import { tokens } from '../tokens';
import { StepSize, StepState } from '../types';
import { getStepState } from '../utils';
import { HorizontalStepBase, HorizontalSeparator, HorizontalNoWrapStackItem, StyledStepNumber } from './styled';
export function HorizontalStepper({ current, defaultCurrent, onChange, steps, filled: _filled, size = StepSize.sm, separator = _jsx(ChevronRightIcon, { type: 'default', size: 'xs', color: tokens.Separator.color }), ...rest }) {
    const [currentStep = 0, setCurrentStep] = useControlledState({
        value: current,
        defaultValue: defaultCurrent,
        onChange
    });
    const onTabChange = (value) => {
        setCurrentStep(Number(value));
    };
    const renderStepIcon = (index, state, disabled) => {
        if (state === StepState.completed) {
            return (_jsx(StepIconContainer, { "$size": size, children: _jsx(CheckPenIcon, { type: 'extended' }) }));
        }
        return (_jsx(StyledStepNumber, { level: size, "$size": size, tone: disabled ? tokens.StepList.horizontal.state.disabled.color : tokens.StepList.horizontal.state[state].color, children: _jsxs("b", { children: [index + 1, "."] }) }));
    };
    const renderStepContent = (label, _details, state, disabled) => (_jsx(HorizontalNoWrapStackItem, { children: _jsx(Text, { level: size, weight: theme.fontWeight.semiBold, tone: disabled ? tokens.StepList.horizontal.state.disabled.color : tokens.StepList.horizontal.state[state].color, children: label }) }));
    const renderSeparator = (index) => {
        if (index >= steps.length - 1)
            return null;
        return _jsx(HorizontalSeparator, { children: separator });
    };
    const renderStep = (step, index) => {
        const { title, label, details, ...stepProps } = step;
        const state = getStepState(index, currentStep);
        const disabled = stepProps.disabled;
        return (_jsxs(React.Fragment, { children: [_jsx(Tooltip, { title: title, children: _jsx(HorizontalStepBase, { ...stepProps, value: index.toString(), "$state": state, style: { height: '100%' }, children: _jsxs(Stack, { direction: 'horizontal', alignY: 'center', gap: tokens.StepList.horizontal.gap, children: [renderStepIcon(index, state, !!disabled), renderStepContent(label, details, state, !!disabled)] }) }) }), renderSeparator(index)] }, index));
    };
    return (_jsx(StyledTabsRoot, { value: currentStep.toString(), onValueChange: onTabChange, dir: 'ltr', variant: TabVariant.underline, "$orientation": 'horizontal', ...rest, children: _jsx(StyledTabsList, { "$orientation": 'horizontal', children: _jsx(Stack, { direction: 'horizontal', alignY: 'center', gap: tokens.StepList.horizontal.gap, children: steps.map(renderStep) }) }) }));
}
